module.exports = __webpack_public_path__ + "img/BoYan.b632e4d0.jpg";